<template>
  <molecule-card>
    <atom-badge :type="isActive ? 'success' : 'danger'">
      {{ formattedStatus }}
    </atom-badge>
    <ion-data-items group-size="three">
      <ion-data-item item-key="Token">
        <span v-if="token.rawToken && !hiddenToken">{{ token.rawToken }}</span>
        <span v-else>************{{ token.last4DigitToken }}</span>
      </ion-data-item>
      <ion-data-item item-key="Issue date">
        {{ token.formattedIssueDate }}
      </ion-data-item>
      <ion-data-item item-key="Last used">
        {{ lastUsedPhrase }}
      </ion-data-item>
      <ion-data-item v-if="!isActive" item-key="Revoked date">
        {{ token.formattedRevokedDate }}
      </ion-data-item>
    </ion-data-items>
    <div class="content-actions">
      <template v-if="token.rawToken">
        <atom-button size="small" icon="copy" type="link-button" @click="copyToken">
          Copy to clipboard
        </atom-button>
        <atom-button :icon="iconName" size="small" type="link-button" @click="toggleToken">
          {{ hideShowLabel }}
        </atom-button>
      </template>
      <atom-button v-if="isActive" size="small" icon="bin" type="link-button" @click="revokeToken">
        Revoke
      </atom-button>
    </div>
  </molecule-card>
</template>

<script lang="ts">
import type { JsonScimGeneratedToken } from "authentication/js/api/scim-tokens.api";
import type { PropType } from "vue";
import AtomBadge from "core/components/atom/badge/AtomBadge.vue";
import AtomButton from "core/components/atom/button/AtomButton.vue";
import IonDataItem from "core/components/ion/dataitems/IonDataItem.vue";
import IonDataItems from "core/components/ion/dataitems/IonDataItems.vue";
import MoleculeCard from "core/components/molecule/card/MoleculeCard.vue";
import showFlashMessage from "core/js/flashmessage/flash-message";
import { capitalizeFirstLetter } from "core/js/string-utils";
import { defineComponent } from "vue";

export default defineComponent({
  components: { IonDataItem, IonDataItems, AtomBadge, MoleculeCard, AtomButton },
  props: {
    token: {
      type: Object as PropType<JsonScimGeneratedToken>,
      required: true,
    },
  },
  data() {
    return {
      hiddenToken: false,
    };
  },
  computed: {
    isActive() {
      return this.token.status === "ACTIVE";
    },
    lastUsedPhrase() {
      return this.token.formattedLastUsedDate || "Not used yet";
    },
    iconName() {
      return this.hiddenToken ? "eye" : "eye-blocked";
    },
    hideShowLabel() {
      return this.hiddenToken ? "Show" : "Hide";
    },
    formattedStatus() {
      return capitalizeFirstLetter(this.token.status.toLocaleLowerCase());
    },
  },
  methods: {
    toggleToken() {
      this.hiddenToken = !this.hiddenToken;
    },
    revokeToken() {
    },
    async copyToken() {
      if (!navigator.clipboard || !this.token.rawToken) {
        return;
      }
      try {
        await navigator.clipboard.writeText(this.token.rawToken);
        showFlashMessage("Copied to clipboard");
      } catch (e) {
        console.error(e);
        showFlashMessage("Could not copy to clipboard", {
          displayType: "danger",
        });
      }
    },
  },
});
</script>

<style scoped lang="scss">
.content-actions {
  border: none;
}
</style>
